import React, { useEffect, useMemo, useState } from 'react';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import { DocumentsUpload } from './DocumentsUpload';
import HeadingTypography from 'src/app/components/shared/Typography/Heading';
import { Document, formateDbGurantors, IGuarantor, IItemsWithCount, IUserEntity, UploadedFile } from '@rasayi-workspace/shared';
import AlertBar from 'src/app/components/shared/Alert';
import { State, City } from 'country-state-city';
import { debounce } from 'lodash';
import { GetTableItems } from '@services';
import { DEFAULT_TABLE_STATE } from '@constants';

const { Item } = Form;
const { Option } = Select;

interface GuarantorsTabProps {
    onClose: () => void;
    onSaveGuarantor: (data: any) => void;
    saveData: (data: any) => void;
    initialValue: IGuarantor[];
    isLoading: boolean;
    exsistingProductLength: number;
    error: { type: 'error' | 'success' | 'info' | 'warning' | ''; message: string };
    setError: (data: { type: 'error' | 'success' | 'info' | 'warning' | ''; message: string }) => void;
    leadId: string;
}
type IOptionLable = 'city' | 'province';
const DEFAULT_GURANTOR = {
    first_name: '',
    last_name: '',
    cnic_number: '',
    email: '',
    primary_mobile: '',
    secondary_mobile: '',
    province: '',
    city: '',
    documents: [],
};
export const GuarantorsTab: React.FC<GuarantorsTabProps> = ({ onClose, onSaveGuarantor, saveData, initialValue, isLoading, exsistingProductLength = 0, error, setError, leadId }) => {
    const [form] = Form.useForm();
    const [guarantors, setGuarantors] = useState<IGuarantor[]>([DEFAULT_GURANTOR]);

    const pakStates = useMemo(
        () =>
            State.getStatesOfCountry('PK').map(state => {
                return {
                    code: state.isoCode,
                    id: state.name,
                    label: state.name,
                };
            }),
        [State]
    );

    const getProvinceCities = (index: number) => {
        const selectedState = pakStates.find(state => state.label === initialValue[index]?.province);
        if (selectedState) {
            return City.getCitiesOfState('PK', selectedState.code).map(state => {
                return {
                    id: state.name,
                    label: state.name,
                };
            });
        }
        return [];
    };

    // Handle document uploads
    const handleDocumentUpload = (index: number, docName: string, files: UploadedFile[]) => {
        setGuarantors(prev => {
            const updated = [...prev];

            const existingDocIndex = updated[index]?.documents?.findIndex(doc => doc.name === docName);

            if (existingDocIndex !== -1) {
                updated[index].documents[existingDocIndex].files = files;
            } else {
                if (!updated[index]) {
                    updated[index] = {
                        first_name: '',
                        last_name: '',
                        cnic_number: '',
                        email: '',
                        primary_mobile: '',
                        secondary_mobile: '',
                        province: '',
                        city: '',
                        documents: [],
                    };
                }

                updated[index].documents.push({ name: docName, files });
            }

            form.setFieldsValue({ guarantors: updated });

            return updated;
        });
    };

    // Handle form submission
    const handleSubmit = (values: any) => {
        setGuarantors(values.guarantors);
        saveData(values.guarantors);
    };

    useEffect(() => {
        if (initialValue.length) {
            form.setFieldsValue({ guarantors: initialValue });
            setGuarantors(initialValue);
        }
    }, [initialValue]);
    const fetchCnicUser = async (cnic: string, index: number) => {
        try {
            const query = `filter=roles.name,eq,customer;cnic_number,eq,${cnic}`;

            const returnedResult: IItemsWithCount<IUserEntity> = await GetTableItems<IUserEntity>(`user?${query}`, ['documents', 'roles'], [], DEFAULT_TABLE_STATE);
            if (returnedResult.items?.length) setUserValuesInForm(returnedResult.items[0], index);
        } catch (error) {}
    };

    const setUserValuesInForm = (values: IUserEntity, index: number) => {
        const gurantors: IGuarantor[] = formateDbGurantors([values]);
        let formatedValues = [...initialValue];
        formatedValues[index] = gurantors[0];
        form.setFieldsValue({ guarantors: formatedValues });
        setGuarantors(formatedValues);
        saveData(formatedValues);
    };

    const fetchCnicDetails = useMemo(() => {
        return debounce((cnic: string, index: number) => {
            fetchCnicUser(cnic, index);
        }, 500);
    }, []);

    return (
        <>
            <AlertBar error={error} setError={setError} />
            <Form
                form={form}
                style={{
                  maxHeight: '700px',
                  overflow: 'hidden',
                }}

                layout="vertical"
                onFinish={handleSubmit}
                onValuesChange={(_, values) => {
                    let formatedValues = values;
                    _.guarantors?.forEach((gu: Partial<IGuarantor>, index: number) => {
                        if (gu?.province && formatedValues?.guarantors?.[index]?.city) {
                            formatedValues.guarantors[index].city = '';
                        }

                        if (gu?.hasOwnProperty('cnic_number') && gu.cnic_number !== undefined) {
                            const cnicRegex = /^\d{5}-\d{7}-\d$/;
                            if (gu.cnic_number === '') formatedValues.guarantors[index] = DEFAULT_GURANTOR;
                            else if (cnicRegex.test(gu.cnic_number)) fetchCnicDetails(gu.cnic_number, index);
                        }
                    });
                    setGuarantors(formatedValues.guarantors);
                    saveData(formatedValues.guarantors);
                }}
            >
                <Form.List name="guarantors" initialValue={guarantors}>
                    {(fields, { add, remove }) => (


                        <>
                        <div
                          style={{
                            maxHeight: '620px',
                            overflowY: 'auto',
                            paddingRight: '8px',
                          }}
                        >
                            {fields.map(({ key, name, ...restField }, index) => (
                                <div key={key} className="pb-[20px]">
                                    <HeadingTypography fontSize={16} classNames="flex items-center h-[26px] font-medium">
                                        Guarantor ({index + 1})
                                    </HeadingTypography>
                                    <Row gutter={[12, 0]}>
                                        {[
                                            { label: 'First Name', field: 'first_name', required: true },
                                            { label: 'Last Name', field: 'last_name', required: true },
                                            {
                                                label: 'CNIC',
                                                field: 'cnic_number',
                                                required: true,
                                                rules: [
                                                    {
                                                        pattern: /^\d{5}-\d{7}-\d$/,
                                                        message: 'CNIC format must be XXXXX-XXXXXXX-X.',
                                                    },
                                                ],
                                            },
                                            {
                                                label: 'Email',
                                                field: 'email',
                                                required: true,
                                                rules: [{ type: 'email' as const, message: 'Enter a valid email address!' }],
                                            },
                                            { label: 'Phone Number', field: 'primary_mobile', required: true },
                                            { label: 'Secondary Phone', field: 'secondary_mobile' },
                                            { label: 'Province', field: 'province', required: true, type: 'select', options: pakStates },
                                            { label: 'City', field: 'city', required: true, type: 'select', options: getProvinceCities(index) },
                                        ].map(({ label, field, required, rules, type, options }) => (
                                            <Col span={8} key={field}>
                                                <Item
                                                    rules={rules}
                                                    {...restField}
                                                    label={
                                                        <HeadingTypography fontSize={14} classNames="flex items-center h-[26px] font-normal">
                                                            {label} {required && <span className="text-[#BD273B]"> *</span>}
                                                        </HeadingTypography>
                                                    }
                                                    name={[name, field]}
                                                >
                                                    {type === 'select' ? (
                                                        <Select
                                                            showSearch
                                                            className="lead-detail-selector w-full"
                                                            allowClear
                                                            placeholder={`Select ${label}`}
                                                            filterSort={(optionA, optionB) =>
                                                                (optionA?.label ?? '')
                                                                    .toString()
                                                                    .toLowerCase()
                                                                    .localeCompare((optionB?.label ?? '').toString().toLowerCase())
                                                            }
                                                        >
                                                            {options?.map((option: any) => (
                                                                <Option key={option.id} value={option.id}>
                                                                    {option.name || option.label}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    ) : (
                                                        <Input style={{ height: '35px' }} placeholder={label} />
                                                    )}
                                                </Item>
                                            </Col>
                                        ))}
                                    </Row>

                                    {/* Document Upload Section */}
                                    <div
                                        style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(3, 1fr)',
                                            gap: '6px',
                                            maxWidth: '100%',
                                            overflowX: 'hidden',
                                        }}
                                    >
                                        {[
                                            { label: 'CNIC', name: 'cnic', maxCount: 3, required: true },
                                            { label: 'Utility Bills', name: 'bills', maxCount: 3 },
                                            { label: 'Cheque', name: 'cheque', maxCount: 3 },
                                        ].map(({ label, name, maxCount, required }) => (
                                            <DocumentsUpload
                                                required={required}
                                                key={name}
                                                title={label}
                                                maxFiles={maxCount}
                                                uploadFiles={files => handleDocumentUpload(index, name, files)}
                                                uploadedFiles={form.getFieldsValue()?.guarantors?.[index]?.documents?.find((doc: Document) => doc.name === name)?.files ?? []}
                                                leadId={leadId}
                                            />
                                        ))}
                                        <div style={{ gridColumn: 'span 3' }}>
                                            <DocumentsUpload
                                                key={name}
                                                uploadedFiles={form.getFieldsValue()?.guarantors?.[index]?.documents?.find((doc: Document) => doc.name === 'others')?.files ?? []}
                                                title="Others"
                                                maxFiles={11}
                                                uploadFiles={files => handleDocumentUpload(index, 'others', files)}
                                                leadId={leadId}
                                            />
                                        </div>
                                    </div>

                                    {/* Remove Guarantor Button */}
                                    {fields.length > 1 && (
                                        <Button disabled={index < exsistingProductLength} danger onClick={() => remove(name)} className="mt-2">
                                            Remove Guarantor {index + 1}
                                        </Button>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div>
                          <div className="flex justify-between items-center">
                                <Button
                                    htmlType="button"
                                    onClick={() => {
                                        add({
                                            first_name: '',
                                            last_name: '',
                                            cnic_number: '',
                                            email: '',
                                            primary_mobile: '',
                                            secondary_mobile: '',
                                            province: '',
                                            city: '',
                                            documents: [],
                                        });
                                    }}
                                    className="text-red-700 border-red-700 bg-white hover:bg-red-700 hover:text-white transition-colors"
                                >
                                    + Add Guarantor
                                </Button>
                                <div className="flex justify-end">
                                    <Button onClick={onClose} className="mr-2 text-red-700 border-red-700 bg-white hover:bg-red-700 hover:text-white transition-colors">
                                        Cancel
                                    </Button>
                                    <Button
                                        loading={isLoading}
                                        onClick={() => {
                                            onSaveGuarantor({});
                                        }}
                                        className="bg-red-700 text-white border-red-700 hover:bg-red-800 hover:border-red-800 hover:text-white transition-colors"
                                    >
                                        Save
                                    </Button>
                                </div>
                            </div>
                        </div>
                        </>
                    )}
                </Form.List>
            </Form>
        </>
    );
};
